import { Menu, X } from "lucide-react";
import React, { useState } from "react";
import logo from "../Assets/Isotipo.png";
import { navItems } from "../Constants";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLinkClick = () => {
    setMobileOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 bg-[#0d1117] border-b border-neutral-800">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img src={logo} alt="DevParts Logo" className="h-9"/>
          <span className="text-xl font-semibold text-white">DevParts</span>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden lg:flex gap-10 text-sm text-neutral-300 font-medium">
          {navItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                className="relative group hover:text-white transition-colors"
              >
                {item.label}
                <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-gradient-to-r from-blue-600 to-blue-400 group-hover:w-full transition-all duration-300"></span>
              </a>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <button onClick={toggleMobileMenu} className="lg:hidden text-white">
          {mobileOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-[#0d1117] border-t border-neutral-800 px-6 pb-4">
          <ul className="flex flex-col gap-4 pt-2">
            {navItems.map((item, index) => (
              <li key={index}>
                <a
                  href={item.href}
                  onClick={handleLinkClick}
                  className="block text-white text-base font-medium hover:text-blue-400 transition-colors"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
